import { PaginationDataResponse } from 'services/api/responses/responseTypes';

export default class PaginationData {
  currentPage: number;

  lastPage: number;

  itemsPerPage: number;

  itemsCount: number;

  totalPages: number;

  totalItems: number;

  constructor(data: PaginationDataResponse) {
    this.currentPage = data.current_page;
    this.lastPage = data.last_page;
    this.itemsPerPage = data.items_per_page;
    this.itemsCount = data.items_count;
    this.totalPages = data.total_pages;
    this.totalItems = data.total_items;
  }
}
